import { observable, computed, action } from 'mobx';
import { CaseEventCategory } from 'types/CaseEventCategory';
import { DefaultEventText } from 'types/DefaultEventText';
import Http from 'services/Http';
import { RequestCategory } from 'types/RequestCategory';
import { RequestEventCategory } from 'types/RequestEventCategory';

export class DefaultEventTextRow { 
    @observable id: number = 0;
    @observable name: string = '';
    @observable defaultValue: string = '';

    @action.bound
    setValue(key: string, val: any) {
        (this as any)[key] = val;
    }

    constructor(txt?: DefaultEventText) {
        if (txt) {
            this.id = txt.id;
            this.name = txt.name;
            this.defaultValue = txt.defaultValue;
        }
    }
}

export class DefaultEventTextStore {

    @observable eventTexts: DefaultEventText[] = [];
    @observable caseEventCategories: CaseEventCategory[] = [];
    @observable requestCategories: RequestCategory[] = [];
    @observable requestEventCategories: RequestEventCategory[] = [];
    
    @observable currentText = new DefaultEventTextRow();

    @computed get eventTextLkp() {
        return new Map<number, DefaultEventText>(this.eventTexts.map(et => [et.id, et]));
    }

    @computed get tableRows(): DefaultEventTextRow[] {
        return this.eventTexts.map(et => {
            let row = new DefaultEventTextRow(et);
            return row;
        })
    }

    @action.bound
    async fetchEventTexts() {
        const res = await Http.get<any>({
            url: 'SystemSettings/GetDefaultEventTexts',
            waitMessage: 'Fetching default event texts, please wait...',
        });
        this.eventTexts = res.defaultEventTexts;
    }

    @action.bound
    async fetchCaseEventCategories() {
        const res = await Http.get<any>({
            url: 'SystemSettings/GetCaseEventCategories',
            waitMessage: 'Fetching case event categories, please wait...',
        });
        this.caseEventCategories = res.caseEventCategories;
    }

    @action.bound
    async fetchRequestCategories() {
        const res = await Http.get<any>({
            url: 'SystemSettings/GetRequestCategories',
            waitMessage: 'Fetching request categories, please wait...',
        });
        this.requestCategories = res.requestCategories;
    }

    @action.bound
    async fetchRequestEventCategories() {
        const res = await Http.get<any>({
            url: 'SystemSettings/GetRequestEventCategories',
            waitMessage: 'Fetching request event categories, please wait...',
        });
        this.requestCategories = res.requestCategories;
    }

    @action.bound
    async fetchAll() {
        //todo: finish APIs.
        await Promise.all([
            this.fetchEventTexts(),
            this.fetchCaseEventCategories(),
            this.fetchRequestCategories(),
            this.fetchRequestEventCategories()
        ]);
    }

    @action.bound
    selectRow(row: DefaultEventText) {
        if (row && row.id === this.currentText.id) {
            this.currentText = new DefaultEventTextRow();
        } else {
            const existingRow = this.tableRows.find(r => r.id === row.id);
            this.currentText = existingRow || new DefaultEventTextRow();
        }
    }

    @action.bound
    resetCurrent() {
        this.currentText = new DefaultEventTextRow();
    }

    @action.bound
    async saveCurrent() {
        await Http.post({ 
            waitMessage: 'Saving default event text, please wait', 
            url: 'SystemSettings/SaveCaseEventCategory', 
            data: this.currentText 
        });

        await this.fetchEventTexts();
    }
}

export default new DefaultEventTextStore()